import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { storage } from '../../firebase/firebase';
import _ from 'lodash'

// import { shortUrl as queryUrl } from '../../graphQl/queries';
import { TRANSACTION_DATA_BY_SHORT_URL, CHECK_CONTRACT_ASSIGNED } from '../../graphQl/subscriptions';
import { TRANSACTION_DATA_BY_SHORT_URL_QUERY, GET_LISTINGDETAILS_BY_SHORTURL } from '../../graphQl/queries';
import { SIGNED_MUTATION, updateCount as countUpdate, ADD_PDF_URL } from '../../graphQl/mutations';
import client from '../../apollo/apollo'
import axios from 'axios';
// import CKEditor from '@ckeditor/ckeditor5-react';
import parse, { domToReact } from 'html-react-parser';
import { renderToStaticMarkup } from 'react-dom/server';
import { Card, Button, Icon, Tooltip, Spin, Layout, Modal, Row, Col, Typography } from 'antd'
import CircularProgress from "components/CircularProgress/index";

import moment from 'moment'
import { message, Popconfirm } from 'antd'
import gql from 'graphql-tag';
import html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import CustomScrollbars from 'util/CustomScrollbars'
import { firebase } from '../../firebase/firebase';

// import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

// import DecoupledEditor from '@ckeditor/ckeditor5-ownbuild-doc-editor/build/ckeditor';
import { withRouter } from 'react-router-dom';
import { CONFIG } from "config/config";
import { getENVConfig } from '../../util/common'
import EcommerceForm from "components/EcommerceForm";
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import Config from '../../util/config'

import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

const initialValue = `<figure class="image"><img src="https://lh5.googleusercontent.com/c3AAb0Tx5S11pDxPe7ifMvSz-gOVPTaF2m-kOPGo7xkz1xWCzL2Ca2SmCJ_bTZRWm-5LZ7f8Wg4MV9TuTf2s68BY3rK8D43Ue1JYN_h7ctog1QiTyl2GFGvdpCj__mkBlbGExtyaaSnZEerdTg" alt="/var/folders/lc/c2qslx9548g2mkcnyzj75cbm0000gp/T/com.microsoft.Word/Content.MSO/9FAEBD8D.tmp"></figure><p>Customer Code:&nbsp;<span class="placeholder">{customerCode}</span></p><p>Shop Name:&nbsp;<span class="placeholder">{shopName}</span></p><p>Address:&nbsp;<span class="placeholder">{address}</span></p><p style="text-align:center;"><strong>Scheme Period:&nbsp;</strong><span class="placeholder">{periodStart}</span><strong>&nbsp;to&nbsp;</strong><span class="placeholder">{periodEnd}</span></p><figure class="table"><table><tbody><tr><td><p style="text-align:center;">Turnover Slab (in Rupees) &nbsp; &nbsp;&nbsp;</p></td></tr><tr><td><p style="text-align:center;"><strong>Value (Pre-Tax)</strong></p></td><td><p style="text-align:right;"><strong>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Incentive &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</strong></p></td></tr><tr><td><strong>Rs.</strong><span class="placeholder">{turnoverValue}</span><strong>&nbsp; &amp; Above in Scheme Period*</strong></td><td><p style="text-align:center;"><span class="placeholder">{incentiveValue}</span><strong>%</strong></p></td></tr></tbody></table></figure><p><span class="text-small">(*Aforementioned Value of RC products to be purchased in period from 02nd Nov 2019 to 20th Dec 2019)</span></p><ul><li><strong><u>There would be an additional 1% ON INVOICE incentive on all purchases during the scheme period with no conditions.&nbsp;</u></strong></li><li>This offer is valid on purchases of products from Royal Canin India Private Limited [RCIPL] (“<strong>Products</strong>”) billed to customers by RCIPL between&nbsp;<span class="placeholder">{periodStart}</span>&nbsp;to&nbsp;<span class="placeholder">{periodEnd}</span><strong>.</strong> (“<strong>Scheme</strong>”).</li><li>RCIPL reserves the right to extend this Scheme in select markets only.</li><li>By participating in the Scheme by signing below, each customer unconditionally agrees to abide by these Terms and Conditions and the decision of RCIPL shall be final and binding in all respects.</li><li>Any evidence of clubbing of purchases or misrepresentation of actual purchase by the customer will lead to immediate disqualification from this Scheme without any claims whatsoever.</li><li><strong>The turnover slabs are calculated in Value (Net Sales Value as per NAVISION excluding GST and other taxes) in the scheme period commencing&nbsp;</strong><span class="placeholder">{periodStart}</span><strong>&nbsp;to&nbsp;</strong><span class="placeholder">{periodEnd}</span></li><li>On successful achieving the Turnover Slab (in value), the appropriate incentive will be calculated on the Net Sales Value (as per Navision excluding GST and other taxes).</li><li>Customers participating in the Scheme are required to clear all outstanding payments against purchases during this program basis the credit terms mentioned on invoice.</li><li>The computation of pay-out would be excluding GST (and other taxes) and only considering Net Sales Value as per NAVISION.</li><li>The Scheme is offered to customers that are registered in NAVISION.</li><li>The pay-out would be reimbursed through credit notes.</li><li>Customers participating in the Scheme are required to clear all outstanding payments against purchases during this program basis the credit terms mentioned on invoice.</li><li>Reimbursement would be done in credit note post clearance of the outstanding payments by the customer.</li><li>All disputes shall be subject to jurisdiction of courts at Mumbai only.</li><li>&nbsp;</li></ul><p>Name of Customer-______________________</p><p>_______________________</p><p>Authorised signatory</p><p>Affix customer stamp</p><p style="text-align:justify;">For <strong>ROYAL CANIN INDIA PRIVATE LIMITED</strong></p><figure class="image image-style-align-left image_resized" style="width:37.66%;"><img src="https://lh6.googleusercontent.com/mCHWQelgdlz25wTEhrxqiByJ-bHPs_W9NzH9gv68cshyCru9waJ7yQDUAL291q0m0yGq1luNfZlKSwDhA-C3Gtm1bDyJJQrGx-kLFWXO37cyRGiqSQLWQeViC1gZ5QRoBt4II0f8xUxyGUMYPg"><figcaption>Authorised Signatory</figcaption></figure><p style="text-align:justify;">&nbsp;</p><p>&nbsp;</p>`;

const publicIp = require('public-ip');

let signedText = "signed"

const { Header, Footer, Sider, Content } = Layout;
class TransactionTemplateView extends Component {

    constructor(props) {
        super(props)
        this.state = {
            shortUrlId: '',
            templateViewData: "",
            transactionData: {},
            transactionFormData: {},
            transactionSignedStatus: "",
            phoneNumberView: "",
            downloadingPdf: false,
            currentUserUid: null,
            isInvalidLink: null,
            loading: false,
            visibleSave: false,
            isSamePhoneNo: null,
            transactionTemplateData: {},
            externalLink: '',
            templateSettings: {},
            showDeeplinkViewApp: true,
            shipmentHistoryModal: false,
            contactNumber: ''
        }
    }

    componentWillMount() {
        const { search } = this.props.location
        console.log('search', search)
        let findUrl = search.includes('uid=');
        console.log('findUrl', findUrl)
        let tempUid = ''
        let tempRole = ''
        if (findUrl) {
            let splitUid = search.split('uid=')
            console.log('splitUid', splitUid)
            let splitRole = splitUid[1].split('&role=')
            console.log('splitRole', splitRole)
            tempUid = splitRole[0]
            tempRole = splitRole[1]
            localStorage.setItem('uid', tempUid)
            localStorage.setItem('role', tempRole)
        }
        console.log('tempUid', tempUid, tempRole)
        this.setState({
            currentUserUid: (findUrl ? tempUid : localStorage.getItem('uid'))
        }, () => {
            console.log('this.state.currentUserUid', this.state.currentUserUid)
            if (!(this.props && this.props.location && this.props.location.state && this.props.location.state.value)) {
                if (this.state.currentUserUid === null) {
                    client.query({ query: GET_LISTINGDETAILS_BY_SHORTURL, variables: { shortURL: this.props.match.params.shortUrl } }).then((_res) => {
                        console.log(_res, '_res_res_res_res')
                        if (_res.data.short_url.length > 0 && _res.data.short_url[0].transaction) {
                            if (_res.data.short_url[0].transaction.type !== 'order') {
                                if (_res.data.short_url[0].transaction.transactionTemplate && _res.data.short_url[0].transaction.transactionTemplate.templateSettings &&
                                    (_res.data.short_url[0].transaction.transactionTemplate.templateSettings.OtpForShortUrl === true)) {
                                    console.log(_res, '_res_res_res_res22')
                                    this.props.history.push({ pathname: '/signin', state: { value: this.state.shortUrlId } })
                                }
                            }
                        }

                        // if (_res.data.short_url.length > 0) {
                        //     if (_res.data.short_url[0].transaction) {
                        //         if (_res.data.short_url[0].transaction.type === 'order') {
                        //             if (_res.data.short_url[0].transaction.transactionTemplate &&
                        //                 _res.data.short_url[0].transaction.transactionTemplate.listing.length > 0) {
                        //                 if (_res.data.short_url[0].transaction.transactionTemplate.listing[0].phoneNumber !== '') {
                        //                     const phoneNumber = parsePhoneNumberFromString(_res.data.short_url[0].transaction.transactionTemplate.listing[0].phoneNumber)
                        //                     if (phoneNumber && phoneNumber.country) {
                        //                         this.props.history.push({
                        //                             pathname: '/signin',
                        //                             state: {
                        //                                 value: this.state.shortUrlId, fromEcommerce: true,
                        //                                 defaultValues: { code: phoneNumber.country.toLowerCase() }
                        //                             }
                        //                         })
                        //                     } else {
                        //                         this.props.history.push({
                        //                             pathname: '/signin',
                        //                             state: { value: this.state.shortUrlId, fromEcommerce: true, defaultValues: { code: 'in' } }
                        //                         })
                        //                     }
                        //                 } else {
                        //                     this.props.history.push({ pathname: '/signin', state: { value: this.state.shortUrlId } })
                        //                 }
                        //             } else {
                        //                 this.props.history.push({ pathname: '/signin', state: { value: this.state.shortUrlId } })
                        //             }
                        //         } else {
                        //             this.props.history.push({ pathname: '/signin', state: { value: this.state.shortUrlId } })
                        //         }
                        //     } else {
                        //         this.props.history.push({ pathname: '/signin', state: { value: this.state.shortUrlId } })
                        //     }
                        // } else {
                        //     this.props.history.push({ pathname: '/signin', state: { value: this.state.shortUrlId } })
                        // }
                    });
                }
            }
        });
        if (this.props && this.props.match && this.props.match.params && this.props.screenName !== 'receivedContract') {
            this.setState({ shortUrlId: this.props.match.params.shortUrl }, async () => {
                await this.fetchDetails()
                await this.updateLinkCount()
            })
        }

        if (this.props && this.props.screenName === 'receivedContract' && this.props.shortUrlId) {
            this.setState({ shortUrlId: this.props.shortUrlId }, async () => {
                await this.fetchDetails()
            })
        }
    }


    fetchDetails() {
        this.setState({ loading: true }, () => {

            const variables = {
                "shortUrl": this.state.shortUrlId
            };

            const gqlValue = TRANSACTION_DATA_BY_SHORT_URL
            const query = gql`
                      ${gqlValue}
                    `
            //get transaction data by short url
            client
                .subscribe({
                    query,
                    variables: variables
                })
                .subscribe(
                    _res => {
                        console.log(_res, 'restrans')
                        //if short url exist in db
                        if (_res.data.short_url.length > 0) {
                            let data = _res.data.short_url[0]
                            if (data && data.transaction) {
                                let checkNumber = Object.keys(data).length > 0 && data.transaction &&
                                    data.transaction.contactRelated ?
                                    data.transaction.contactRelated.phoneNumber : false;
                                if (checkNumber) {
                                    this.setState({ contactNumber: checkNumber })
                                }
                                //Note: find opening via site, of from email/sms
                                const { search } = this.props.location;
                                //find link is
                                let _inapp = search.includes('inapp');

                                if ((data.transaction.transactionTemplate && data.transaction.transactionTemplate.templateSettings &&
                                    (data.transaction.transactionTemplate.templateSettings.OtpForShortUrl === null ||
                                        data.transaction.transactionTemplate.templateSettings.OtpForShortUrl === undefined ||
                                        data.transaction.transactionTemplate.templateSettings.OtpForShortUrl === false))) {
                                    this.setState({ isSamePhoneNo: true }, () => {
                                        let value = _res.data.short_url[0]

                                        let formData = _res.data.short_url[0].transaction.formData
                                        let template = value.transaction && value.transaction.transactionTemplate &&
                                            value.transaction.transactionTemplate.displayTemplate ?
                                            value.transaction.transactionTemplate.displayTemplate : ""
                                        // let template = _res.data.short_url[0].transaction.transactionTemplate.displayTemplate
                                        let signedStatus = _res.data.short_url[0].transaction.transactionTemplate.signedStatus

                                        if (template !== '') {
                                            const options = {
                                                replace: ({ attribs, children }) => {
                                                    //for contract singing block
                                                    if (!attribs) return;
                                                    if (attribs && attribs.name) {
                                                        for (var key in formData) {
                                                            if (formData.hasOwnProperty(key)) {
                                                                var findText = key.includes(signedText);
                                                                if (findText) {
                                                                    var splitedText = key.split(signedText);
                                                                    var splitedVarible = splitedText[1].split('_');
                                                                    let name = ''
                                                                    if (splitedVarible[0]) {
                                                                        name = splitedVarible[0]
                                                                    }
                                                                    if (splitedVarible[1]) {
                                                                        name = name + ' ' + splitedVarible[1]
                                                                    }


                                                                    if ((attribs.name === name)) {
                                                                        if (formData[key]) {
                                                                            return (
                                                                                <span style={{ fontWeight: 400 }}>{formData[key]}</span>
                                                                            )
                                                                        } else {
                                                                            return <span style={{ fontWeight: 400 }}>-</span>
                                                                        }
                                                                    }

                                                                }

                                                            }

                                                        }
                                                    }

                                                    //for variable replacing
                                                    children.map((childernData, index) => {

                                                        if (childernData.data) {
                                                            var data = childernData.data;
                                                            var regex = /\[\[((\w+)]\])/g;
                                                            var variable = data.match(regex);
                                                            var label = '';
                                                            if (variable && variable.length > 0) {
                                                                variable.map((vdata, vindex) => {

                                                                    for (var key in formData) {
                                                                        if (formData.hasOwnProperty(key)) {
                                                                            let replacedValue = ''
                                                                            label = vdata.replace(/[^A-Z0-9]/ig, "");
                                                                            if ((key.toString() === label) && formData[key]) {
                                                                                data = data.replace(`[[${label}]]`, formData[key]);
                                                                                children[index].data = data
                                                                                return children
                                                                            }
                                                                            if ((key.toString() === label) && formData[key]) {

                                                                            }
                                                                            if (label === formData[key]) {
                                                                                children[index].data = data;
                                                                            }
                                                                        } else { return }
                                                                    }
                                                                })
                                                            }
                                                        }

                                                        else if (childernData.name === 'input' || childernData.name === 'textarea') {
                                                            if (childernData.attribs && childernData.attribs.name) {
                                                                for (var key in formData) {
                                                                    if (formData.hasOwnProperty(key)) {
                                                                        childernData.attribs.name = childernData.attribs.name.replace(/[^A-Z0-9]/ig, "");

                                                                        if ((childernData.attribs.name === key) && (formData[key] !== '')) {
                                                                            children[index].data = formData[key];
                                                                            children[index].type = 'text'
                                                                            return children
                                                                        }

                                                                    }

                                                                }
                                                            }
                                                        }
                                                    });
                                                }
                                            }

                                            this.setState({
                                                templateViewData: `${renderToStaticMarkup(parse(template, options))}`
                                            }, () => {
                                            })
                                        }

                                        this.setState({
                                            transactionData: _res.data.short_url[0].transaction,
                                            pdfURL: _res.data.short_url[0].pdfURL,
                                            transactionFormData: _res.data.short_url[0].transaction.formData,
                                            transactionSignedStatus: signedStatus,
                                            isInvalidLink: false,
                                            loading: false,
                                            transactionTemplateData: _res.data.short_url[0].transaction ?
                                                _res.data.short_url[0].transaction.transactionTemplate : {},
                                            externalLink: _res.data.short_url[0].transaction &&
                                                _res.data.short_url[0].transaction.transactionTemplate &&
                                                _res.data.short_url[0].transaction.transactionTemplate.templatepublicurl ?
                                                _res.data.short_url[0].transaction.transactionTemplate.templatepublicurl : '',
                                            templateSettings: _res.data.short_url[0].transaction &&
                                                _res.data.short_url[0].transaction &&
                                                _res.data.short_url[0].transaction.transactionTemplate &&
                                                _res.data.short_url[0].transaction.transactionTemplate.templateSettings ?
                                                _res.data.short_url[0].transaction.transactionTemplate.templateSettings : {}
                                        }, () => {


                                            const temp = `
                                    <div style="position:relative;bottom:10px;">
                                    <div style="display: flex; flex-direction: column; align-items: flex-end; height: 30px;">
                                    ${this.state.transactionData.contactRelated ?
                                                    this.state.transactionData.contactRelated.phoneNumber ?
                                                        `<p>Phone Number: ${this.state.transactionData.contactRelated.phoneNumber}</p>`
                                                        :
                                                        `<p>Phone Number: - </p>`
                                                    :
                                                    `<p>Phone Number: - </p>`
                                                }
                                    <p>Signed IP: ${this.state.transactionData.signedIP}</p>
                                    ${this.state.transactionData.formData &&
                                                this.state.transactionData.formData.signedAt &&
                                                `<p>Signed At: ${moment(this.state.transactionData.formData.signedAt).format('LLLL')}</p>`
                                                }
                                    </div>
                                    </div>`
                                            this.setState({ phoneNumberView: temp })
                                        })

                                    })
                                } else {
                                    //FOR listing admin no condtions to access
                                    if (localStorage.getItem('role') && localStorage.getItem('role') === 'listingAdmin') {
                                        this.setState({ isSamePhoneNo: true }, () => {

                                            let value = _res.data.short_url[0]

                                            let formData = _res.data.short_url[0].transaction.formData
                                            let template = value.transaction && value.transaction.transactionTemplate &&
                                                value.transaction.transactionTemplate.displayTemplate ?
                                                value.transaction.transactionTemplate.displayTemplate : ""
                                            let signedStatus = _res.data.short_url[0].transaction.transactionTemplate.signedStatus
                                            if (template !== '') {
                                                const options = {
                                                    replace: ({ attribs, children }) => {
                                                        //for contract singing block
                                                        if (!attribs) return;
                                                        if (attribs && attribs.name) {
                                                            for (var key in formData) {
                                                                if (formData.hasOwnProperty(key)) {
                                                                    var findText = key.includes(signedText);
                                                                    if (findText) {
                                                                        var splitedText = key.split(signedText);
                                                                        var splitedVarible = splitedText[1].split('_');
                                                                        let name = ''
                                                                        if (splitedVarible[0]) {
                                                                            name = splitedVarible[0]
                                                                        }
                                                                        if (splitedVarible[1]) {
                                                                            name = name + ' ' + splitedVarible[1]
                                                                        }

                                                                        if ((attribs.name === name)) {
                                                                            if (formData[key]) {
                                                                                return (
                                                                                    <span style={{ fontWeight: 400 }}>{formData[key]}</span>
                                                                                )
                                                                            } else {
                                                                                return <span style={{ fontWeight: 400 }}>-</span>
                                                                            }
                                                                        }

                                                                    }

                                                                }

                                                            }
                                                        }

                                                        //for variable replacing
                                                        children.map((childernData, index) => {

                                                            if (childernData.data) {
                                                                var data = childernData.data;
                                                                var regex = /\[\[((\w+)]\])/g;
                                                                var variable = data.match(regex);
                                                                var label = '';
                                                                if (variable && variable.length > 0) {
                                                                    variable.map((vdata, vindex) => {

                                                                        for (var key in formData) {
                                                                            if (formData.hasOwnProperty(key)) {
                                                                                let replacedValue = ''
                                                                                label = vdata.replace(/[^A-Z0-9]/ig, "");
                                                                                if ((key.toString() === label) && formData[key]) {
                                                                                    data = data.replace(`[[${label}]]`, formData[key]);
                                                                                    children[index].data = data
                                                                                    return children
                                                                                }
                                                                                if ((key.toString() === label) && formData[key]) {

                                                                                }
                                                                                if (label === formData[key]) {
                                                                                    children[index].data = data;
                                                                                }
                                                                            } else { return }
                                                                        }
                                                                    })
                                                                }
                                                            }

                                                            else if (childernData.name === 'input' || childernData.name === 'textarea') {
                                                                if (childernData.attribs && childernData.attribs.name) {
                                                                    for (var key in formData) {
                                                                        if (formData.hasOwnProperty(key)) {
                                                                            childernData.attribs.name = childernData.attribs.name.replace(/[^A-Z0-9]/ig, "");
                                                                            if ((childernData.attribs.name === key) && (formData[key] !== '')) {
                                                                                children[index].data = formData[key];
                                                                                children[index].type = 'text'
                                                                                return children
                                                                            }

                                                                        }

                                                                    }
                                                                }
                                                            }
                                                        });
                                                    }
                                                }


                                                this.setState({
                                                    templateViewData: `${renderToStaticMarkup(parse(template, options))}`
                                                }, () => {
                                                })
                                            }

                                            this.setState({
                                                transactionData: _res.data.short_url[0].transaction,
                                                pdfURL: _res.data.short_url[0].pdfURL,
                                                transactionFormData: _res.data.short_url[0].transaction.formData,
                                                transactionSignedStatus: signedStatus,
                                                isInvalidLink: false,
                                                loading: false,
                                                transactionTemplateData: _res.data.short_url[0].transaction ?
                                                    _res.data.short_url[0].transaction.transactionTemplate : {},
                                                externalLink: _res.data.short_url[0].transaction &&
                                                    _res.data.short_url[0].transaction.transactionTemplate &&
                                                    _res.data.short_url[0].transaction.transactionTemplate.templatepublicurl ?
                                                    _res.data.short_url[0].transaction.transactionTemplate.templatepublicurl : '',
                                                templateSettings: _res.data.short_url[0].transaction &&
                                                    _res.data.short_url[0].transaction &&
                                                    _res.data.short_url[0].transaction.transactionTemplate &&
                                                    _res.data.short_url[0].transaction.transactionTemplate.templateSettings ?
                                                    _res.data.short_url[0].transaction.transactionTemplate.templateSettings : {}
                                            }, () => {
                                                const temp = `
                                                        <div>
                                                    <div style="display: flex; flex-direction: column; align-items: flex-end; height: 30px;">
                                                    ${this.state.transactionData.contactRelated ?
                                                        this.state.transactionData.contactRelated.phoneNumber ?
                                                            `<p>Phone Number: ${this.state.transactionData.contactRelated.phoneNumber}</p>`
                                                            :
                                                            `<p>Phone Number: - </p>`
                                                        :
                                                        `<p>Phone Number: - </p>`
                                                    }
                                                <p>Signed IP: ${this.state.transactionData.signedIP}</p>
                                                    ${this.state.transactionData.formData &&
                                                    this.state.transactionData.formData.signedAt &&
                                                    `<p>Signed At: ${moment(this.state.transactionData.formData.signedAt).format('LLLL')}</p>`
                                                    }
                                                </div>
                                            </div>`
                                                this.setState({ phoneNumberView: temp })
                                            })

                                        })

                                    } else {
                                        let transactionType = data.transaction.transactionTemplate &&
                                            data.transaction.transactionTemplate.type ? data.transaction.transactionTemplate.type : ""

                                        //check in assigned members list
                                        if ((localStorage.getItem("uid")) || (transactionType === "order")) {
                                            const gqlValue2 = CHECK_CONTRACT_ASSIGNED
                                            const query = gql`
                                          ${gqlValue2}
                                        `
                                            client
                                                .subscribe({
                                                    query,
                                                    variables: { transactionId: data.transaction.id, userId: localStorage.getItem('uid') }
                                                })
                                                .subscribe(
                                                    asignres => {
                                                        //if exist
                                                        if (asignres.data.transaction_assigned_to.length > 0) {
                                                            this.setState({ isSamePhoneNo: true }, () => {
                                                                let value = _res.data.short_url[0]

                                                                let formData = _res.data.short_url[0].transaction.formData
                                                                let template = value.transaction && value.transaction.transactionTemplate &&
                                                                    value.transaction.transactionTemplate.displayTemplate ?
                                                                    value.transaction.transactionTemplate.displayTemplate : ""
                                                                // let template = _res.data.short_url[0].transaction.transactionTemplate.displayTemplate
                                                                let signedStatus = _res.data.short_url[0].transaction.transactionTemplate.signedStatus

                                                                if (template !== '') {
                                                                    const options = {
                                                                        replace: ({ attribs, children }) => {
                                                                            //for contract singing block
                                                                            if (!attribs) return;
                                                                            if (attribs && attribs.name) {
                                                                                for (var key in formData) {
                                                                                    if (formData.hasOwnProperty(key)) {
                                                                                        var findText = key.includes(signedText);
                                                                                        if (findText) {
                                                                                            var splitedText = key.split(signedText);
                                                                                            var splitedVarible = splitedText[1].split('_');
                                                                                            let name = ''
                                                                                            if (splitedVarible[0]) {
                                                                                                name = splitedVarible[0]
                                                                                            }
                                                                                            if (splitedVarible[1]) {
                                                                                                name = name + ' ' + splitedVarible[1]
                                                                                            }


                                                                                            if ((attribs.name === name)) {
                                                                                                if (formData[key]) {
                                                                                                    return (
                                                                                                        <span style={{ fontWeight: 400 }}>{formData[key]}</span>
                                                                                                    )
                                                                                                } else {
                                                                                                    return <span style={{ fontWeight: 400 }}>-</span>
                                                                                                }
                                                                                            }

                                                                                        }

                                                                                    }

                                                                                }
                                                                            }

                                                                            //for variable replacing
                                                                            children.map((childernData, index) => {

                                                                                if (childernData.data) {
                                                                                    var data = childernData.data;
                                                                                    var regex = /\[\[((\w+)]\])/g;
                                                                                    var variable = data.match(regex);
                                                                                    var label = '';
                                                                                    if (variable && variable.length > 0) {
                                                                                        variable.map((vdata, vindex) => {

                                                                                            for (var key in formData) {
                                                                                                if (formData.hasOwnProperty(key)) {
                                                                                                    let replacedValue = ''
                                                                                                    label = vdata.replace(/[^A-Z0-9]/ig, "");
                                                                                                    if ((key.toString() === label) && formData[key]) {
                                                                                                        data = data.replace(`[[${label}]]`, formData[key]);
                                                                                                        children[index].data = data
                                                                                                        return children
                                                                                                    }
                                                                                                    if ((key.toString() === label) && formData[key]) {

                                                                                                    }
                                                                                                    if (label === formData[key]) {
                                                                                                        children[index].data = data;
                                                                                                    }
                                                                                                } else { return }
                                                                                            }
                                                                                        })
                                                                                    }
                                                                                }

                                                                                else if (childernData.name === 'input' || childernData.name === 'textarea') {
                                                                                    if (childernData.attribs && childernData.attribs.name) {
                                                                                        for (var key in formData) {
                                                                                            if (formData.hasOwnProperty(key)) {
                                                                                                childernData.attribs.name = childernData.attribs.name.replace(/[^A-Z0-9]/ig, "");

                                                                                                if ((childernData.attribs.name === key) && (formData[key] !== '')) {
                                                                                                    children[index].data = formData[key];
                                                                                                    children[index].type = 'text'
                                                                                                    return children
                                                                                                }

                                                                                            }

                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }
                                                                    }

                                                                    this.setState({
                                                                        templateViewData: `${renderToStaticMarkup(parse(template, options))}`
                                                                    }, () => {
                                                                    })
                                                                }

                                                                this.setState({
                                                                    transactionData: _res.data.short_url[0].transaction,
                                                                    pdfURL: _res.data.short_url[0].pdfURL,
                                                                    transactionFormData: _res.data.short_url[0].transaction.formData,
                                                                    transactionSignedStatus: signedStatus,
                                                                    isInvalidLink: false,
                                                                    loading: false,
                                                                    transactionTemplateData: _res.data.short_url[0].transaction ?
                                                                        _res.data.short_url[0].transaction.transactionTemplate : {},
                                                                    externalLink: _res.data.short_url[0].transaction &&
                                                                        _res.data.short_url[0].transaction.transactionTemplate &&
                                                                        _res.data.short_url[0].transaction.transactionTemplate.templatepublicurl ?
                                                                        _res.data.short_url[0].transaction.transactionTemplate.templatepublicurl : '',
                                                                    templateSettings: _res.data.short_url[0].transaction &&
                                                                        _res.data.short_url[0].transaction &&
                                                                        _res.data.short_url[0].transaction.transactionTemplate &&
                                                                        _res.data.short_url[0].transaction.transactionTemplate.templateSettings ?
                                                                        _res.data.short_url[0].transaction.transactionTemplate.templateSettings : {}
                                                                }, () => {


                                                                    const temp = `
                                                        <div style="position:relative;bottom:10px;">
                                                        <div style="display: flex; flex-direction: column; align-items: flex-end; height: 30px;">
                                                        ${this.state.transactionData.contactRelated ?
                                                                            this.state.transactionData.contactRelated.phoneNumber ?
                                                                                `<p>Phone Number: ${this.state.transactionData.contactRelated.phoneNumber}</p>`
                                                                                :
                                                                                `<p>Phone Number: - </p>`
                                                                            :
                                                                            `<p>Phone Number: - </p>`
                                                                        }
                                                        <p>Signed IP: ${this.state.transactionData.signedIP}</p>
                                                        ${this.state.transactionData.formData &&
                                                                        this.state.transactionData.formData.signedAt &&
                                                                        `<p>Signed At: ${moment(this.state.transactionData.formData.signedAt).format('LLLL')}</p>`
                                                                        }
                                                        </div>
                                                        </div>`
                                                                    this.setState({ phoneNumberView: temp })
                                                                })

                                                            })
                                                        }
                                                        //if not exist
                                                        else {
                                                            //check loggedin phone no and phone number in short url transaction is same
                                                            if (checkNumber || (transactionType === "order")) {
                                                                if (localStorage.getItem("phoneNumber") || (transactionType === "order")) {
                                                                    //is same numbers so pdf
                                                                    if ((localStorage.getItem("phoneNumber").substr(localStorage.getItem('phoneNumber').length - 10) ===
                                                                        checkNumber.substr(checkNumber.length - 10)) || _inapp || (transactionType === "order")) {
                                                                        this.setState({ isSamePhoneNo: true }, () => {

                                                                            let value = _res.data.short_url[0]

                                                                            let formData = _res.data.short_url[0].transaction.formData
                                                                            let template = value.transaction && value.transaction.transactionTemplate &&
                                                                                value.transaction.transactionTemplate.displayTemplate ?
                                                                                value.transaction.transactionTemplate.displayTemplate : ""
                                                                            let signedStatus = _res.data.short_url[0].transaction.transactionTemplate.signedStatus
                                                                            if (template !== '') {
                                                                                const options = {
                                                                                    replace: ({ attribs, children }) => {
                                                                                        //for contract singing block
                                                                                        if (!attribs) return;
                                                                                        if (attribs && attribs.name) {
                                                                                            for (var key in formData) {
                                                                                                if (formData.hasOwnProperty(key)) {
                                                                                                    var findText = key.includes(signedText);
                                                                                                    if (findText) {
                                                                                                        var splitedText = key.split(signedText);
                                                                                                        var splitedVarible = splitedText[1].split('_');
                                                                                                        let name = ''
                                                                                                        if (splitedVarible[0]) {
                                                                                                            name = splitedVarible[0]
                                                                                                        }
                                                                                                        if (splitedVarible[1]) {
                                                                                                            name = name + ' ' + splitedVarible[1]
                                                                                                        }

                                                                                                        if ((attribs.name === name)) {
                                                                                                            if (formData[key]) {
                                                                                                                return (
                                                                                                                    <span style={{ fontWeight: 400 }}>{formData[key]}</span>
                                                                                                                )
                                                                                                            } else {
                                                                                                                return <span style={{ fontWeight: 400 }}>-</span>
                                                                                                            }
                                                                                                        }

                                                                                                    }

                                                                                                }

                                                                                            }
                                                                                        }

                                                                                        //for variable replacing
                                                                                        children.map((childernData, index) => {

                                                                                            if (childernData.data) {
                                                                                                var data = childernData.data;
                                                                                                var regex = /\[\[((\w+)]\])/g;
                                                                                                var variable = data.match(regex);
                                                                                                var label = '';
                                                                                                if (variable && variable.length > 0) {
                                                                                                    variable.map((vdata, vindex) => {

                                                                                                        for (var key in formData) {
                                                                                                            if (formData.hasOwnProperty(key)) {
                                                                                                                let replacedValue = ''
                                                                                                                label = vdata.replace(/[^A-Z0-9]/ig, "");
                                                                                                                if ((key.toString() === label) && formData[key]) {
                                                                                                                    data = data.replace(`[[${label}]]`, formData[key]);
                                                                                                                    children[index].data = data
                                                                                                                    return children
                                                                                                                }
                                                                                                                if ((key.toString() === label) && formData[key]) {

                                                                                                                }
                                                                                                                if (label === formData[key]) {
                                                                                                                    children[index].data = data;
                                                                                                                }
                                                                                                            } else { return }
                                                                                                        }
                                                                                                    })
                                                                                                }
                                                                                            }

                                                                                            else if (childernData.name === 'input' || childernData.name === 'textarea') {
                                                                                                if (childernData.attribs && childernData.attribs.name) {
                                                                                                    for (var key in formData) {
                                                                                                        if (formData.hasOwnProperty(key)) {
                                                                                                            childernData.attribs.name = childernData.attribs.name.replace(/[^A-Z0-9]/ig, "");
                                                                                                            if ((childernData.attribs.name === key) && (formData[key] !== '')) {
                                                                                                                children[index].data = formData[key];
                                                                                                                children[index].type = 'text'
                                                                                                                return children
                                                                                                            }

                                                                                                        }

                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        });
                                                                                    }
                                                                                }


                                                                                this.setState({
                                                                                    templateViewData: `${renderToStaticMarkup(parse(template, options))}`
                                                                                }, () => {
                                                                                })
                                                                            }

                                                                            this.setState({
                                                                                transactionData: _res.data.short_url[0].transaction,
                                                                                pdfURL: _res.data.short_url[0].pdfURL,
                                                                                transactionFormData: _res.data.short_url[0].transaction.formData,
                                                                                transactionSignedStatus: signedStatus,
                                                                                isInvalidLink: false,
                                                                                loading: false,
                                                                                transactionTemplateData: _res.data.short_url[0].transaction ?
                                                                                    _res.data.short_url[0].transaction.transactionTemplate : {},
                                                                                externalLink: _res.data.short_url[0].transaction &&
                                                                                    _res.data.short_url[0].transaction.transactionTemplate &&
                                                                                    _res.data.short_url[0].transaction.transactionTemplate.templatepublicurl ?
                                                                                    _res.data.short_url[0].transaction.transactionTemplate.templatepublicurl : '',
                                                                                templateSettings: _res.data.short_url[0].transaction &&
                                                                                    _res.data.short_url[0].transaction &&
                                                                                    _res.data.short_url[0].transaction.transactionTemplate &&
                                                                                    _res.data.short_url[0].transaction.transactionTemplate.templateSettings ?
                                                                                    _res.data.short_url[0].transaction.transactionTemplate.templateSettings : {}
                                                                            }, () => {


                                                                                const temp = `
                                                    <div>
                                                    <div style="display: flex; flex-direction: column; align-items: flex-end; height: 30px;">
                                                    ${this.state.transactionData.contactRelated ?
                                                                                        this.state.transactionData.contactRelated.phoneNumber ?
                                                                                            `<p>Phone Number: ${this.state.transactionData.contactRelated.phoneNumber}</p>`
                                                                                            :
                                                                                            `<p>Phone Number: - </p>`
                                                                                        :
                                                                                        `<p>Phone Number: - </p>`
                                                                                    }
                                                    <p>Signed IP: ${this.state.transactionData.signedIP}</p>
                                                    ${this.state.transactionData.formData &&
                                                                                    this.state.transactionData.formData.signedAt &&
                                                                                    `<p>Signed At: ${moment(this.state.transactionData.formData.signedAt).format('LLLL')}</p>`
                                                                                    }
                                                    </div>
                                                    </div>`
                                                                                this.setState({ phoneNumberView: temp })
                                                                            })

                                                                        })
                                                                    }

                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    //if not same number, so unauthorized error 
                                                                    else {
                                                                        this.setState({ isSamePhoneNo: false, loading: false }, () => {
                                                                            this.redirectToLogin()
                                                                        })
                                                                    }
                                                                }
                                                                //if user not loggedin
                                                                else {
                                                                    this.props.history.push({ pathname: '/signin', state: { value: this.state.shortUrlId } })
                                                                }
                                                            } else {
                                                                this.setState({ isSamePhoneNo: false, loading: false }, () => {
                                                                    this.redirectToLogin()
                                                                })
                                                            }
                                                        }
                                                    });
                                        }
                                        else {
                                            if (checkNumber || (transactionType === "order")) {
                                                if (localStorage.getItem("phoneNumber") || (transactionType === "order")) {
                                                    //is same numbers so pdf
                                                    if ((localStorage.getItem("phoneNumber").substr(localStorage.getItem('phoneNumber').length - 10) ===
                                                        checkNumber.substr(checkNumber.length - 10)) || _inapp || (transactionType === "order")) {
                                                        this.setState({ isSamePhoneNo: true }, () => {

                                                            let value = _res.data.short_url[0]

                                                            let formData = _res.data.short_url[0].transaction.formData
                                                            let template = value.transaction && value.transaction.transactionTemplate &&
                                                                value.transaction.transactionTemplate.displayTemplate ?
                                                                value.transaction.transactionTemplate.displayTemplate : ""
                                                            let signedStatus = _res.data.short_url[0].transaction.transactionTemplate.signedStatus
                                                            if (template !== '') {
                                                                const options = {
                                                                    replace: ({ attribs, children }) => {
                                                                        //for contract singing block
                                                                        if (!attribs) return;
                                                                        if (attribs && attribs.name) {
                                                                            for (var key in formData) {
                                                                                if (formData.hasOwnProperty(key)) {
                                                                                    var findText = key.includes(signedText);
                                                                                    if (findText) {
                                                                                        var splitedText = key.split(signedText);
                                                                                        var splitedVarible = splitedText[1].split('_');
                                                                                        let name = ''
                                                                                        if (splitedVarible[0]) {
                                                                                            name = splitedVarible[0]
                                                                                        }
                                                                                        if (splitedVarible[1]) {
                                                                                            name = name + ' ' + splitedVarible[1]
                                                                                        }

                                                                                        if ((attribs.name === name)) {
                                                                                            if (formData[key]) {
                                                                                                return (
                                                                                                    <span style={{ fontWeight: 400 }}>{formData[key]}</span>
                                                                                                )
                                                                                            } else {
                                                                                                return <span style={{ fontWeight: 400 }}>-</span>
                                                                                            }
                                                                                        }

                                                                                    }

                                                                                }

                                                                            }
                                                                        }

                                                                        //for variable replacing
                                                                        children.map((childernData, index) => {

                                                                            if (childernData.data) {
                                                                                var data = childernData.data;
                                                                                var regex = /\[\[((\w+)]\])/g;
                                                                                var variable = data.match(regex);
                                                                                var label = '';
                                                                                if (variable && variable.length > 0) {
                                                                                    variable.map((vdata, vindex) => {

                                                                                        for (var key in formData) {
                                                                                            if (formData.hasOwnProperty(key)) {
                                                                                                let replacedValue = ''
                                                                                                label = vdata.replace(/[^A-Z0-9]/ig, "");
                                                                                                if ((key.toString() === label) && formData[key]) {
                                                                                                    data = data.replace(`[[${label}]]`, formData[key]);
                                                                                                    children[index].data = data
                                                                                                    return children
                                                                                                }
                                                                                                if ((key.toString() === label) && formData[key]) {

                                                                                                }
                                                                                                if (label === formData[key]) {
                                                                                                    children[index].data = data;
                                                                                                }
                                                                                            } else { return }
                                                                                        }
                                                                                    })
                                                                                }
                                                                            }

                                                                            else if (childernData.name === 'input' || childernData.name === 'textarea') {
                                                                                if (childernData.attribs && childernData.attribs.name) {
                                                                                    for (var key in formData) {
                                                                                        if (formData.hasOwnProperty(key)) {
                                                                                            childernData.attribs.name = childernData.attribs.name.replace(/[^A-Z0-9]/ig, "");
                                                                                            if ((childernData.attribs.name === key) && (formData[key] !== '')) {
                                                                                                children[index].data = formData[key];
                                                                                                children[index].type = 'text'
                                                                                                return children
                                                                                            }

                                                                                        }

                                                                                    }
                                                                                }
                                                                            }
                                                                        });
                                                                    }
                                                                }


                                                                this.setState({
                                                                    templateViewData: `${renderToStaticMarkup(parse(template, options))}`
                                                                }, () => {
                                                                })
                                                            }

                                                            this.setState({
                                                                transactionData: _res.data.short_url[0].transaction,
                                                                pdfURL: _res.data.short_url[0].pdfURL,
                                                                transactionFormData: _res.data.short_url[0].transaction.formData,
                                                                transactionSignedStatus: signedStatus,
                                                                isInvalidLink: false,
                                                                loading: false,
                                                                transactionTemplateData: _res.data.short_url[0].transaction ?
                                                                    _res.data.short_url[0].transaction.transactionTemplate : {},
                                                                externalLink: _res.data.short_url[0].transaction &&
                                                                    _res.data.short_url[0].transaction.transactionTemplate &&
                                                                    _res.data.short_url[0].transaction.transactionTemplate.templatepublicurl ?
                                                                    _res.data.short_url[0].transaction.transactionTemplate.templatepublicurl : '',
                                                                templateSettings: _res.data.short_url[0].transaction &&
                                                                    _res.data.short_url[0].transaction &&
                                                                    _res.data.short_url[0].transaction.transactionTemplate &&
                                                                    _res.data.short_url[0].transaction.transactionTemplate.templateSettings ?
                                                                    _res.data.short_url[0].transaction.transactionTemplate.templateSettings : {}
                                                            }, () => {


                                                                const temp = `
                                    <div>
                                    <div style="display: flex; flex-direction: column; align-items: flex-end; height: 30px;">
                                    ${this.state.transactionData.contactRelated ?
                                                                        this.state.transactionData.contactRelated.phoneNumber ?
                                                                            `<p>Phone Number: ${this.state.transactionData.contactRelated.phoneNumber}</p>`
                                                                            :
                                                                            `<p>Phone Number: - </p>`
                                                                        :
                                                                        `<p>Phone Number: - </p>`
                                                                    }
                                    <p>Signed IP: ${this.state.transactionData.signedIP}</p>
                                    ${this.state.transactionData.formData &&
                                                                    this.state.transactionData.formData.signedAt &&
                                                                    `<p>Signed At: ${moment(this.state.transactionData.formData.signedAt).format('LLLL')}</p>`
                                                                    }
                                    </div>
                                    </div>`
                                                                this.setState({ phoneNumberView: temp })
                                                            })

                                                        })
                                                    }

                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    //if not same number, so unauthorized error 
                                                    else {
                                                        this.setState({ isSamePhoneNo: false, loading: false }, () => {
                                                            this.redirectToLogin()
                                                        })
                                                    }
                                                }
                                                //if user not loggedin
                                                else {
                                                    this.props.history.push({ pathname: '/signin', state: { value: this.state.shortUrlId } })
                                                }
                                            } else {
                                                console.log('else check', this.state.currentUserUid)
                                                this.props.history.push({ pathname: '/signin', state: { value: this.state.shortUrlId } })
                                            }
                                        }
                                    }
                                }
                            } else {
                                this.setState({ isInvalidLink: true, loading: false })
                            }
                        }
                        //if short url not exist
                        else {
                            this.setState({ isInvalidLink: true, loading: false })
                        }
                    },
                    err => {
                        this.setState({ loading: false })
                    }
                )
        })

    }

    //if unauthorized access to user, redirect to login screen after 2 secs
    redirectToLogin = () => {
        setTimeout(() => {
            this.onLogoutUser();
        }, 5000);
    }

    updateLinkCount = () => {
        //update link opening count
        //Note: dont update link count if opening via app, (only from email/sms)
        const { search } = this.props.location;
        //find link is 
        let _inapp = search.includes('inapp');



        if (!_inapp) {
            const variables = {
                "shortUrl": this.state.shortUrlId
            };
            client.query({ query: TRANSACTION_DATA_BY_SHORT_URL_QUERY, variables: variables }).then((_res) => {
                if (_res.data.short_url.length > 0) {

                    let data = _res.data.short_url[0]
                    let checkNumber = Object.keys(data).length > 0 && data.transaction &&
                        data.transaction.contactRelated ?
                        data.transaction.contactRelated.phoneNumber : false;

                    //check loggedin phone no and phone number in short url transaction is same
                    if (checkNumber) {
                        if (localStorage.getItem("phoneNumber")) {
                            //if same, update count
                            if ((localStorage.getItem("phoneNumber").substr(localStorage.getItem('phoneNumber').length - 10) ===
                                checkNumber.substr(checkNumber.length - 10))) {
                                this.updateCount(_res.data.short_url[0])
                            }
                        }
                    }

                }
            }).catch((err) => {
            })

        }
    }


    //update link count for transaction
    updateCount = (data) => {
        if (data && data.shortURL) {
            let count = data.linkClickCount + 1;

            client.mutate({
                mutation: countUpdate,
                variables: {
                    shortUrl: data.shortURL,
                    count: Number(count)
                }
            }).then((_res) => {

            }).catch((_err) => {
            })
        }
    }

    onSaveConfirm = () => {
        this.setState({
            visibleSave: true
        })
    }

    onSave = async () => {

        // this.setState({
        //     loading: true
        // })
        let values = this.state.transactionData
        let signatureFormData = {}

        var inputs, index;
        inputs = document.getElementsByTagName('input');
        for (index = 0; index < inputs.length; ++index) {
            var s = inputs[index].name;
            let replacedValue = s.replace(/\s+/g, '_');
            let updatedName = "signed" + replacedValue
            if (inputs[index].type === 'checkbox') {
                if (inputs[index].checked) {
                    values.formData[updatedName] = true;
                    signatureFormData[updatedName] = true;
                }
            }
            else if (inputs[index].type === 'radio') {
                if (inputs[index].checked) {
                    values.formData[updatedName] = true;
                    signatureFormData[updatedName] = true;
                }
            } else {
                values.formData[updatedName] = inputs[index].value;
                values.formData[replacedValue] = inputs[index].value;
                signatureFormData[updatedName] = inputs[index].value;
            }
        }
        values.formData['signedAt'] = String(new Date());
        values.formData['version'] = Config.version;

        //for text area tag
        var inputsText = document.getElementsByTagName('textarea');
        var indextext = 0;
        if (inputsText.length > 0) {
            for (indextext = 0; indextext < inputsText.length; ++indextext) {
                var s = inputsText[indextext].name;
                let replacedValue = s.replace(/\s+/g, '_');
                let updatedName = "signed" + replacedValue
                values.formData[updatedName] = inputsText[indextext].value;
                values.formData[replacedValue] = inputsText[index].value;
                if (inputs.length > 0) {
                    signatureFormData[updatedName] = inputs[indextext].value;
                }
            }
        }

        let userIp = await publicIp.v4();
        let updatedAt = moment().format()
        let variables = {
            "currentStatus": this.state.transactionSignedStatus,
            "signedIP": userIp,
            "transactionId": this.state.transactionData.id,
            "createdBy": localStorage.getItem('uid'),
            "updatedAt": updatedAt,
            "statusUpdatedAt": updatedAt,
            "formData": values.formData
        }
        const isEmptyvalue = !Object.values(signatureFormData).every(x => (x !== null && x !== ''));

        if (isEmptyvalue === false) {
            let response = await client.mutate({ mutation: SIGNED_MUTATION, variables: variables }).then((response) => {
                this.setState({
                    visibleSave: false,
                    loading: false
                })
                message.success('Submitted Successfully')
            });
        } else {
            this.setState({
                visibleSave: false,
                loading: false
            })
            message.success("Please fill all the form fields")
        }


    }

    downloadPdf = () => {
        console.log(this.state.transactionTemplateData, ' this.state.transactionTemplateData.')
        // if (this.state.pdfURL) {
        //     // var windowRef = window.open();
        //     // windowRef.location = uploadUrl;
        //     window.open(this.state.pdfURL, '_self');
        // } else {  
        this.setState({ downloadingPdf: true });
        var mydiv = document.getElementById("qr-code-view");
        const qrCodeCanvas = document.querySelector('canvas');
        console.log(qrCodeCanvas, 'qrcanvas')
        if (qrCodeCanvas) {
            const qrCodeDataUri = qrCodeCanvas.toDataURL('image/jpg', 0.3);
            console.log(mydiv, 'heiii')
            mydiv.innerHTML += `<img src="${qrCodeDataUri}" id="product-title-image"/>`
        }

        var input = document.getElementById('divToPrint');
        let style = `<style>
        table {border-top: 1px solid; border-left: 1px solid; overflow-x: hidden} 
        td {
          border-bottom: 1px solid ; border-right: 1px solid;
        }
        tr > th{
            border-right:1px solid;
            border-bottom: 1px solid ;
        }
        textarea{
            width:100%;
        }
        html {
            padding-right: 20px;
            padding-left: 20px;
        }
        .ant-row{
            display:flex;
        }
        #summary-first-text{
            width:40%;
        }
        
        .ant-row > div{
            /*display:flex;*/
            // width:30% !important;
        }
        .ant-col.ant-col-xs-13.ant-col-md-10{
            /*display:flex;*/
            width:65% !important;
        }
        table{
            width:100% !important;
        }
        .text-area-container{
            padding-bottom:10px;
        }
        h4 {
            color: #535353;
            font-weight: 600;
        }
        #delivery-type-view{
            align-items:center;
        }
        #delivery-type-view  p{
            margin-top:0;
            margin-bottom:0;
            
        }
        #details-view-text{
            width:35% !important;
            padding-right:15px;
            
        }
        .order-Name-detail{
            text-align:center;
            margin-bottom:25px;
        }
        #delivery-type-view{
            display:flex;
            
        }
        #delivery-type-view p{
            padding-right:15px;
            width:50%;
            justify-content:flex-end;
            display:flex;
        }
        #address-seq-view, #address-seq-container{
            display:flex;
        }
        #address-seq-view {
              width: 50%;
              padding-right: 15px;
              display:flex;
            //   justify-content:flex-end;
        } 
        p.total-unit-value {
            width:40% !important;
            text-align:right !important; 
            color:black;
          }
          span.ant-typography.total-unit-value {
              width: 20%;
              text-align: center;
              color:black;
          }
        .total-after-tax{
            width:100%;
             display: flex;
            justify-content: flex-end;
        }
        #order-container-summarry p{
            margin-bottom:0px;
            margin-top:0;
            
        }
        .tax-value-view{
            display: flex;
            justify-content: flex-end;
            width:78%;
            
        }
        .total-content-modal{
            width:22%;
             display: flex;
            justify-content: flex-end;
            text-align:right;
            
        }
       #details-view-text > span {
          line-height: normal !important;
         letter-spacing: normal !important;
         display: inline-block;
         overflow: visible;
         font-family: arial !important;
         color: black !important;
         width:100%;
         margin-bottom:10px;
         font-weight: 500;
         font-size: 14px;
       }
     .list-view-content .ant-row{
             flex-direction:row;
        }
        .delivery-container{
            display:flex;
            justify-content:center;
            margin-top:11px;
        }
        .delivery-container .ant-form-item-label{
            padding-right:20px;
            width:50%;
            display:flex;
        }
        .delivery-container label{
           
            text-align: right;
            color: black;
            font-weight:500;
        }
        #address-seq-view p{
            color:black !important;
            font-weight:500;
        }
        #image-qr-view{
            display: flex !important; 
            justify-content: center !important;
          }
          #form-upl-profile{
            object-fit: fill !important;
          }
          #qr-code-view{
            position: absolute !important;
            right: 10px !important;
            display: flex;
            justify-content: center;
            padding-bottom: 25px;
          }
          #order-summary-container{
              margin-bottom:30px !important;
          }
          #delivery-modal-container{
              margin-top:30px !important;
          }
          #product-title-image ,.sb-avatar__text{
              width:120px !important;
              height:120px !important;
          }
          #form-upl-profile{
            width:120px !important;
            height:120px !important;
          }
          #title-view , .total-unit-value , .total-unit-value{
            font-weight: 300 !important;
            color: black;
        }
        #summary-first-text ,#title-view{
            font-family: unset !important;
          }
          #summary-total-container{
              display:flex !important;
              align-items:baseline !important;
          }
          .pubilc-url-title{
            margin-top:5px !important;
            margin-bottom:5px !important;
        }
        .total-after-tax{
            margin-top:15px !important;
            margin-bottom:15px !important;
        }
        #delivery-modal-container{
            margin-top:5px !important;
            margin-bottom:5px !important;
            padding-left:0px !important;
            padding-right:0px !important;
        }
        .order_form-details{
            padding-top:0px !important;
            margin-top:0px !important;
        }
        .order_form > div{
            margin-bottom:0px !important;
        }
        #delivery-modal-container h4{
            margin-top:5px !important;
            margin-bottom:8px !important; 
        }
        #order-summary-container h4{
            margin-top:5px !important;
            margin-bottom:8px !important;
        }
        #order-Name-detail{
            margin-bottom:20px !important;
        }
        .quantity-container-total #title-view{
            margin-bottom:5px !important;
        }
        #summary-total-container{
            margin-bottom:10px !important;
            margin-top:10px !important;
        }
        #summary-total-container p{
            margin-top:0 !important;
            margin-bottom:0 !important;
        }
        .pubilc-url-detail{
            margin-bottom:5px !important;
            margin-top:5px !important;
        }
        #order-summary-container .pubilc-url-title{
            margin-bottom:12px !important;
            margin-top:5px !important;
        }
        #details-view-text > span{
            margin-bottom:1px !important;
        }
        #order-form-address,#read-only-details{
            display: flex;
            flex-wrap: wrap;
            width: 100%;
          }
          #address-seq-container ,.list-view-content{
            width: 50%;
          }
         .order-delivery-inform .ant-col.ant-form-item-control-wrapper.ant-col-xs-24.ant-col-sm-24.ant-col-md-4.ant-col-lg-12{
            width: 50%;
          }
          #address-seq-detail{
            color:black !important;
          }
          .order-delivery-inform .delivery-container > div{
            color:black !important
          }
          p,h4,label{
            font-family: arial !important;
            font-size:14px !important;
            word-wrap: break-word;
          }
          #personal-details-view{
              padding-right:10px;
          }
          #customer-info-detail .ant-col.ant-form-item-label.ant-col-xs-24.ant-col-sm-24.ant-col-md-12.ant-col-lg-12{
              width:30%;
          }
      </style>`;
        // input = '<html>' + input.innerHTML + `<style>
        let bottomElements = '';
        if (qrCodeCanvas) {
            bottomElements = this.state.transactionTemplateData.templateSettings ?
                this.state.transactionTemplateData.templateSettings.displaySignedData ?
                    this.state.phoneNumberView + style
                    : style
                : style;
        } else {
            bottomElements = this.state.transactionTemplateData.templateSettings ?
                this.state.transactionTemplateData.templateSettings.displaySignedData ?
                    this.state.phoneNumberView + style
                    : style
                : style;
        }


        input = '<html>' + input.innerHTML + bottomElements + `</html>`;
        console.log(input, 'ipipipi')
        axios({
            'method': 'POST',
            url: `${getENVConfig(CONFIG.CLOUDFUNCTIONS)}/pdfconvertPuppeteer`,
            // url: `http://localhost:5001/totely-dev1/us-central1/pdfconvertPuppeteer`,
            headers: { 'Content-Type': 'application/json' },
            data: {
                htmlData: JSON.stringify(input), name: this.state.shortUrlId,
                transactionType: this.state.transactionData.transactionTemplate.type,
                orderFile: this.state.transactionData && this.state.transactionData.attachmentUrls && this.state.transactionData.attachmentUrls.attachedUrl && this.state.transactionData.attachmentUrls.attachedUrl.length > 0 && this.state.transactionData.attachmentUrls.attachedUrl[0]
            }
        }).then((response) => {
            storage
                .ref(response.data.pdfUrl.name)
                .getDownloadURL()
                .then(uploadUrl => {
                    const param = { pdfURL: uploadUrl, shortURL: this.state.shortUrlId }
                    client.mutate({ mutation: ADD_PDF_URL, variables: param }).then(() => {
                        window.open(uploadUrl, '_self');
                    }).catch((err) => {
                        message.error("viewing pdf failed!")
                    });
                })
                .catch((errr) => {
                    message.error("viewing pdf failed!")
                });
            this.setState({ downloadingPdf: false });
        })
            .catch((err) => {
                this.setState({ downloadingPdf: false });
            })
            .catch((err) => {
                this.setState({ downloadingPdf: false });
            })
            .catch((err) => {
                this.setState({ downloadingPdf: false });
                message.error("viewing pdf failed!")
            });
    }

    handleCancel = () => {
        this.setState({
            visibleSave: false
        })
    }

    //on logout user
    onLogoutUser = () => {
        //call firebase signout function
        firebase.auth().signOut()
            .then(async () => {
                // Sign-out successful.
                await localStorage.clear();
                window.sessionStorage.clear();
                window.indexedDB.deleteDatabase("firebaseLocalStorageDb");
                this.props.history.push({ pathname: '/signin', state: { value: this.state.shortUrlId } })
            }, (error) => {
            });
    }

    renderUserSignedData = () => {
        return (

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', paddingRight: '3%' }}>
                {
                    this.state.transactionData && this.state.transactionData.contactRelated &&
                    this.state.transactionData.contactRelated.phoneNumber &&
                    <p>Phone Number: {this.state.transactionData.contactRelated.phoneNumber}</p>
                }
                <p>Signed IP: {this.state.transactionData.signedIP}</p>
                {
                    this.state.transactionData.formData &&
                    this.state.transactionData.formData.signedAt &&
                    <p>Signed At: {moment(this.state.transactionData.formData.signedAt).format('LLLL')}</p>
                }

            </div>
        )
    }

    onClickNewOrder = () => {
        const { externalLink, transactionTemplateData } = this.state
        const listingName = transactionTemplateData &&
            transactionTemplateData.listing[0] &&
            transactionTemplateData.listing[0].listing_urls[0] && transactionTemplateData.listing[0].listing_urls[0].urlName ?
            transactionTemplateData.listing[0].listing_urls[0].urlName : ''
        if (externalLink && listingName) {
            const link = getENVConfig(CONFIG.DOMAIN) + '/' + listingName + '/' + externalLink
            window.open(link, '_self')
        } else {
            message.error('No external link')
        }
    }


    locale = (string) => {
        if ((Object.keys(this.state.transactionData).length > 0)) {
            if (this.state.transactionData.formData.LocalizationDetailValues &&
                this.state.transactionData.formData.LocalizationDetailValues.length > 0 &&
                this.state.transactionData.formData.LocalizationDetailValues.find(item => item.DefaultValue === string)) {
                return this.state.transactionData.formData.LocalizationDetailValues.find(item => item.DefaultValue === string).AlternateValue
            } else {
                return string
            }
        } else {
            if (this.state.transactionTemplateData.templateSettings.LocalizationDetailValues &&
                this.state.transactionTemplateData.templateSettings.LocalizationDetailValues.length > 0 &&
                this.state.transactionTemplateData.templateSettings.LocalizationDetailValues.find(item => item.DefaultValue === string)) {
                return this.state.transactionTemplateData.templateSettings.LocalizationDetailValues.find(item => item.DefaultValue === string).AlternateValue
            } else {
                return string
            }
        }
    }

    render() {

        const { isInvalidLink, isSamePhoneNo, transactionTemplateData, templateSettings, transactionData, contactNumber } = this.state
        const { screenName } = this.props
        const { Text } = Typography
        let showedAlready = true;

        const headerValue = templateSettings && templateSettings.fieldValues && templateSettings.fieldValues.HeaderDetailValues && templateSettings.fieldValues.HeaderDetailValues.length > 0 ? templateSettings.fieldValues.HeaderDetailValues : []
        // Note: Show pdf to assigned members in transaction and to whom we have sent transaction 
        let deeplinkurl = transactionTemplateData && transactionTemplateData.shorturlForDeeplink
            ? transactionTemplateData.shorturlForDeeplink : ""
        const shipmentValue = transactionData && transactionData.shipmentStatus && transactionData.shipmentStatus.length > 0 ? transactionData.shipmentStatus : []
        console.log(shipmentValue.length, 'this.state.transactionData')
        let shipment = {}
        if (shipmentValue.length > 0) {
            shipment = shipmentValue[shipmentValue.length - 1].TrackResponse
            // shipmentStatus[item.shipmentStatus.length - 1].TrackResponse
        }

        console.log(shipment, "jawashipment", contactNumber)
        console.log(shipmentValue, "jawashipmentValue", this.state.templateViewData, this.state.transactionData)
        return (
            <div style={{
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: 20
            }}>
                <Spin spinning={this.state.loading}
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh'
                    }}
                >

                    {/* user phone number not matched */}
                    {
                        isSamePhoneNo === false &&
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100vh'
                        }}>
                            <h5>Incorrect number. Redirecting to Login page in 5 seconds...</h5>
                            {/* <h5>Unauthorized access. Click <a style={{
                            color: '#38a2d4',
                            textDecoration: 'underline'
                        }} onClick={() => this.onLogoutUser()}>here</a> to login with the correct phone number.</h5> */}
                        </div>
                        // <img src={require('../../assets/images/403.png')} />
                    }
                    {
                        isSamePhoneNo === false &&
                        <img src={require('../../assets/images/403.png')} />
                    }
                    {
                        isInvalidLink === false &&
                        <CustomScrollbars className="gx-todo-detail-content-scroll" id="pdf-custom-scrollbar">
                            <Card className={screenName === "receivedContract" ? "contract-list-form" : "pdf-container-card"}>
                                <Card className={screenName === "receivedContract" ? "contract-list-card" : this.state.transactionData.transactionTemplate.type === 'order' ?
                               (this.state.showDeeplinkViewApp && deeplinkurl
                                    && this.state.templateViewData === ''
                                    && this.state.transactionTemplateData.displayTemplateType === 'EcommerceForm'
                                    ) ? "baanner-ecommerce-view" : "ecommorce-view" : "pdf-modal-content"} >

                                    {this.state.transactionData && this.state.transactionData.signedIP === null && ((
                                        (this.state.transactionData.transactionTemplate &&
                                            this.state.transactionData.transactionTemplate.templateSettings &&
                                            (this.state.transactionData.transactionTemplate.templateSettings.OtpForShortUrl === null ||
                                                this.state.transactionData.transactionTemplate.templateSettings.OtpForShortUrl === undefined ||
                                                this.state.transactionData.transactionTemplate.templateSettings.OtpForShortUrl === false))) ? true : (contactNumber &&
                                                    (localStorage.getItem("phoneNumber") && localStorage.getItem("phoneNumber").substr(localStorage.getItem('phoneNumber').length - 10) ===
                                                        contactNumber.substr(contactNumber.length - 10)))) &&
                                    <Layout className="sticky" id="transaction-sticky-view">
                                        <Header className="sticky-header">
                                            <div id="transaction-submit-button" style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>

                                                <div>

                                                    <Button type="primary" onClick={this.onSaveConfirm}>Submit</Button>

                                                </div>


                                            </div>
                                        </Header>
                                    </Layout>
                                    }

                                    {
                                        this.state.transactionData && this.state.transactionData.signedIP &&

                                        <Layout className="sticky" id="transaction-sticky-view">
                                            <Header className="sticky-header">

                                                <div id="transaction-submit-button" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                    <div id="transaction-title-view">
                                                        {headerValue && headerValue.length > 0 && headerValue.map(res => (
                                                            <div>
                                                                {res && res.attributeType && (res.attributeType === "Name" ||
                                                                    res.attributeType === "name") &&
                                                                    <h3 style={{ fontWeight: 500, cursor: "pointer" }}>{_.startCase(res.attributeValue)}</h3>
                                                                }
                                                            </div>
                                                        ))
                                                        }
                                                    </div>
                                                </div>
                                                <div id="transaction-button-view">

                                                    {/* {this.state.templateViewData === '' && this.state.transactionTemplateData.displayTemplateType === 'EcommerceForm' &&
                                                        <Button type="primary" onClick={() => this.onClickNewOrder()}>
                                                            {this.locale('New order')}
                                                        </Button>
                                                    } */}
                                                    {this.state.templateViewData && this.state.transactionTemplateData.displayTemplateType !== 'EcommerceForm' &&
                                                        <Spin
                                                            spinning={this.state.downloadingPdf}
                                                            tip="Generating PDF..."
                                                            id="pdfSpinnerText"
                                                        >
                                                            <Tooltip title="View as PDF" style={{ zIndex: 9999 }}>
                                                                <Icon id="icon-view" type="eye" style={{ fontSize: '25px', marginLeft: 10 }} onClick={() => this.downloadPdf()} />
                                                            </Tooltip>

                                                        </Spin>
                                                    }
                                                    {this.state.transactionTemplateData.displayTemplateType === 'EcommerceForm' &&
                                                        <Spin
                                                            spinning={this.state.downloadingPdf}
                                                            tip="Generating PDF..."
                                                            id="pdfSpinnerText"
                                                        >
                                                            {/* <Tooltip title="View as PDF" style={{ zIndex: 9999 }}>
                                                                <Icon id="icon-view" type="eye" style={{ fontSize: '25px', marginLeft: 10 }} onClick={() => this.downloadPdf()} />
                                                            </Tooltip> */}
                                                            <div style={{ cursor: 'pointer' }} onClick={() => this.downloadPdf()} >Print PDF</div>

                                                        </Spin>
                                                    }

                                                </div>
                                            </Header>
                                        </Layout>

                                    }

                                    <BrowserView>
                                        {this.state.transactionData.attachmentUrls && this.state.transactionData.attachmentUrls.attachedUrl.length > 0 &&
                                            <iframe src={`${this.state.transactionData.attachmentUrls.attachedUrl[0]}#toolbar=0`} width='100%' height='1200px'></iframe>
                                        }
                                    </BrowserView>
                                    {this.state.templateViewData === '' && this.state.transactionTemplateData.displayTemplateType === 'EcommerceForm' ?

                                        <div id="divToPrint">
                                            <EcommerceForm
                                                listingId={this.state.transactionTemplateData ? this.state.transactionTemplateData.listing[0].id : ''}
                                                templateId={this.state.transactionTemplateData ? this.state.transactionTemplateData.id : ""}
                                                transactionData={this.state.transactionData}
                                            />
                                        </div>
                                        :
                                        <div>
                                            {this.state.templateViewData === '' && this.state.transactionTemplateData.displayTemplateType === "ShipmentForm" ?
                                                <div>

                                                    {this.state.transactionTemplateData.templateSettings &&
                                                        this.state.transactionTemplateData.templateSettings.fieldValues &&
                                                        this.state.transactionTemplateData.templateSettings.fieldValues.HeaderDetailValues &&
                                                        this.state.transactionTemplateData.templateSettings.fieldValues.HeaderDetailValues.length > 0 &&
                                                        this.state.transactionTemplateData.templateSettings.fieldValues.HeaderDetailValues.map((res) => {
                                                            if (res && res.attributeType && (res.attributeType === "Name" ||
                                                                res.attributeType === "name") && !showedAlready) {
                                                                showedAlready = true;
                                                                return <h3 id="order-title-content" style={{ fontWeight: 500, cursor: "pointer" }}>{_.startCase(res.attributeValue)}</h3>
                                                            }
                                                        })
                                                    }
                                                    {this.state.transactionTemplateData.templateSettings &&
                                                        this.state.transactionTemplateData.templateSettings.fieldValues &&
                                                        this.state.transactionTemplateData.templateSettings.fieldValues.HeaderImage &&
                                                        this.state.transactionTemplateData.templateSettings.fieldValues.HeaderImage.showImage &&
                                                        this.state.transactionTemplateData.templateSettings.fieldValues.HeaderImage.ImageDetail &&
                                                        this.state.transactionTemplateData.templateSettings.fieldValues.HeaderImage.ImageDetail[0] &&
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <img
                                                                // id="form-upl-profile"
                                                                style={{ width: '35%' }}
                                                                src={this.state.transactionTemplateData.templateSettings.fieldValues.HeaderImage.ImageDetail[0].url}
                                                            />
                                                        </div>
                                                    }

                                                    {this.state.transactionData &&
                                                        this.state.transactionData.formData &&

                                                        <div>
                                                            <h6 className="order-Name-detail" id="transaction-details-header">Transaction Details</h6>

                                                            {this.state.transactionData &&
                                                                this.state.transactionData.recipientBusinessContact &&
                                                                <div>
                                                                    <Row id="order-view-contain" style={{ marginBottom: '2%' }}>
                                                                        <Col xs={12} md={12} lg={12} id="order-id-view">
                                                                            <Text> Business Account Name: </Text>
                                                                        </Col>
                                                                        <Col xs={12} md={12} className="sub-details">
                                                                            <Text>{this.state.transactionData.recipientBusinessContact.name}</Text>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            }

                                                            {this.state.transactionData.formData.transactionSectionDetails &&
                                                                this.state.transactionData.formData.transactionSectionDetails.length > 0 &&
                                                                this.state.transactionData.formData.transactionSectionDetails.map((transactData) => (

                                                                    <div>
                                                                        <Row id="order-view-contain" style={{ marginBottom: '2%' }}>
                                                                            <Col xs={12} md={12} lg={12} id="order-id-view">
                                                                                <Text> {transactData.attributeName}: </Text>
                                                                            </Col>
                                                                            <Col xs={12} md={12} className="sub-details">
                                                                                <Text>{transactData.attributeType !== 'Option' ? transactData.attributeValue !== '' ? transactData.attributeValue : '-' :
                                                                                    transactData.duplicateAttributeValue ? transactData.duplicateAttributeValue !== '' ? transactData.duplicateAttributeValue : '-' : '-'}</Text>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                ))
                                                            }

                                                            {this.state.transactionData.formData.documentSectionDetails &&
                                                                this.state.transactionData.formData.documentSectionDetails.length > 0 &&
                                                                this.state.transactionData.formData.documentSectionDetails.map((transactData) => (

                                                                    <div>
                                                                        <Row id="order-view-contain" style={{ marginBottom: '2%' }}>
                                                                            <Col xs={12} md={12} lg={12} id="order-id-view">
                                                                                <Text> {transactData.attributeName}: </Text>
                                                                            </Col>
                                                                            <Col xs={12} md={12} className="sub-details">

                                                                                <Text
                                                                                    style={{}}
                                                                                    onClick={() => transactData.attributeValue &&
                                                                                        transactData.attributeValue.url &&
                                                                                        window.open(transactData.attributeValue.url)}
                                                                                ></Text>
                                                                                <a href={transactData.attributeValue &&
                                                                                    transactData.attributeValue.url}
                                                                                    target="_blank"
                                                                                >
                                                                                    {transactData.attributeValue && transactData.attributeValue.name !== '' ?
                                                                                        transactData.attributeValue.name : '-'}
                                                                                </a>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                ))
                                                            }

                                                        </div>
                                                    }



                                                    {this.state.transactionData &&
                                                        this.state.transactionData.currentStatus &&
                                                        <div style={{ marginTop: '17px' }}>
                                                            <h6 className="order-Name-detail" id="transaction-details-header">Shipment Details</h6>

                                                            <Row id="order-view-contain" style={{ marginBottom: '2%' }}>
                                                                <Col xs={12} md={12} lg={12} id="order-id-view">
                                                                    <Text> Current Status: </Text>
                                                                </Col>
                                                                <Col xs={12} md={12} className="sub-details">
                                                                    <Text>{this.state.transactionData.currentStatus}</Text>
                                                                </Col>
                                                            </Row>
                                                            {shipmentValue.length > 0 &&


                                                                <div>

                                                                    {shipment.msg.tag !== 'Delivered' && shipment.msg.expected_delivery &&
                                                                        <Row id="order-view-contain" style={{ marginBottom: '2%' }}>
                                                                            <Col xs={12} md={12} lg={12} id="order-id-view">
                                                                                <Text>Expected Delivery : </Text>
                                                                            </Col>
                                                                            <Col xs={12} md={12} className="sub-details" style={{ display: 'grid' }}>
                                                                                <Text>
                                                                                    {moment(shipment.msg.expected_delivery).format('ll')}
                                                                                </Text>
                                                                            </Col>
                                                                        </Row>
                                                                    }

                                                                    {shipment.msg.tag === 'Delivered' && shipment.msg.shipment_delivery_date &&
                                                                        <Row id="order-view-contain" style={{ marginBottom: '2%' }}>
                                                                            <Col xs={12} md={12} lg={12} id="order-id-view">
                                                                                <Text>  Delivery Date : </Text>
                                                                            </Col>
                                                                            <Col xs={12} md={12} className="sub-details" style={{ display: 'grid' }}>
                                                                                <Text>
                                                                                    {moment(shipment.msg.shipment_delivery_date).format('ll')}
                                                                                </Text>
                                                                            </Col>
                                                                        </Row>
                                                                    }
                                                                </div>
                                                            }

                                                            {/* <div>: </div> */}
                                                            {this.state.transactionData.shipmentStatus &&
                                                                this.state.transactionData.shipmentStatus.length > 0 &&
                                                                this.state.transactionData.shipmentStatus[0].TrackResponse &&
                                                                this.state.transactionData.shipmentStatus[0].TrackResponse.msg &&
                                                                this.state.transactionData.shipmentStatus[0].TrackResponse.msg.checkpoints &&
                                                                this.state.transactionData.shipmentStatus[0].TrackResponse.msg.checkpoints.length > 0 &&
                                                                <Row id="order-view-contain" className="shipment-status-view" style={{ marginBottom: '2%' }} onClick={() => { this.setState({ shipmentHistoryModal: true }) }}>
                                                                    <Col xs={12} md={12} lg={12} id="order-id-view">
                                                                        <Text> Shipment Status: </Text>
                                                                    </Col>

                                                                    <Col xs={12} md={12} className="sub-details" style={{ display: 'grid' }}>
                                                                        <Text className="shipment-track-link">{this.state.transactionData.shipmentStatus[0].TrackResponse.msg.checkpoints
                                                                        [this.state.transactionData.shipmentStatus[0].TrackResponse.msg.checkpoints.length - 1].message}</Text>
                                                                        {/* </Col>
                                                                    <Col xs={12} md={12} className="sub-details"> */}
                                                                        <Text>{this.state.transactionData.shipmentStatus[0].TrackResponse.msg.checkpoints
                                                                        [this.state.transactionData.shipmentStatus[0].TrackResponse.msg.checkpoints.length - 1].location}</Text>
                                                                        {/* </Col>
                                                                    <Col xs={12} md={12} className="sub-details"> */}
                                                                        <Text > Updated at {moment(this.state.transactionData.shipmentStatus[0].TrackResponse.msg.checkpoints
                                                                        [this.state.transactionData.shipmentStatus[0].TrackResponse.msg.checkpoints.length - 1].created_at).format("MMMM Do YYYY, h:mm a")}</Text>
                                                                    </Col>
                                                                </Row>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                                :
                                                <p id="divToPrint"
                                                    className="templetePdf"
                                                    style={{ width: '100%' }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: `<html> ${this.state.templateViewData}<style>input {
                                        display: block !important;
                                        font-size: 1rem !important;
                                        color: #495057 !important;
                                        background-color: #fff !important;
                                        background-clip: padding-box !important;
                                        border: 1px solid #ced4da !important;
                                        border-radius: .25rem !important;
                                        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
                                      }</style></html>` }} />
                                            }

                                            {/* user signed data */}
                                            {/* Note: for lead template, show signed data is displaySignedData value is true */}
                                            {
                                                this.state.transactionData && this.state.transactionData.signedIP &&
                                                <div>
                                                    {
                                                        transactionTemplateData && transactionTemplateData.templateSettings ?
                                                            <div>
                                                                {
                                                                    transactionTemplateData.templateSettings.displaySignedData === true &&
                                                                    this.renderUserSignedData()
                                                                }
                                                            </div> :
                                                            this.renderUserSignedData()
                                                    }
                                                </div>
                                            }
                                        </div>
                                    }

                                    <Footer id="short-url-version" style={{ position: 'absolute', bottom: 25, width: '100%', left: 0 }}>
                                        <div>
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <p style={{ fontSize: 10 }}> V {Config.version}</p>
                                            </div>
                                        </div>
                                    </Footer>



                                </Card>

                            </Card>
                        </CustomScrollbars>
                    }



                    {/* <Layout>

                    <Footer style={{color:"red"}}>Footer</Footer>
                </Layout> */}
                    <Modal
                        width={250}
                        visible={this.state.visibleSave}
                        onOk={() => this.onSave()}
                        onCancel={this.handleCancel}
                        okText="Yes"
                        cancelText="No"
                        closable={false}
                        centered={true}
                    >
                        <b>Are you sure to submit it?</b>
                    </Modal>

                    <Modal
                        width={'55%'}
                        visible={this.state.shipmentHistoryModal}
                        // onOk={() => this.onSave()}
                        onCancel={() => { this.setState({ shipmentHistoryModal: false }) }}
                        closable={true}
                        footer={null}
                        className="shipment-details-model"
                    >
                        <div style={{ width: '100%', textAlign: 'center', fontSize: 20, marginBottom: 30, padding: 12, backgroundColor: '#fff' }}>
                            <b>Shipment History</b>
                        </div>
                        {this.state.transactionData.shipmentStatus &&
                            this.state.transactionData.shipmentStatus.length > 0 &&
                            this.state.transactionData.shipmentStatus[0].TrackResponse &&
                            this.state.transactionData.shipmentStatus[0].TrackResponse.msg &&
                            this.state.transactionData.shipmentStatus[0].TrackResponse.msg.checkpoints &&
                            this.state.transactionData.shipmentStatus[0].TrackResponse.msg.checkpoints.length > 0 &&
                            <div className="shipment-details-container">
                                {this.state.transactionData.shipmentStatus[0].TrackResponse.msg.checkpoints.map((data, index) => (
                                    <div style={{ marginTop: 10, marginBottom: 10, flexDirection: 'column', display: 'flex', backgroundColor: '#fff', padding: 15, margin: 20 }}>
                                        <Text>{data.message}</Text>
                                        < Text > {
                                            data.location
                                        }
                                        </Text>

                                        <Text> Updated at {moment(data.checkpoint_time).format("MMMM Do YYYY, h:mm a")}</Text>
                                    </div>
                                ))}
                            </div>
                        }
                    </Modal>


                    {
                        isInvalidLink === true &&
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100vh'
                        }}>
                            <h5 style={{ color: 'red' }}>The link is either invalid or expired</h5>
                        </div>

                    }

                </Spin>

                {/* deeplink url view */}
                {
                    this.state.showDeeplinkViewApp && deeplinkurl
                    && this.state.templateViewData === ''
                    && this.state.transactionTemplateData.displayTemplateType === 'EcommerceForm'
                    &&
                    <MobileView>
                        <div style={{
                            width: '100%',
                            height: 50,
                            backgroundColor: '#038fde',
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'flex',
                            position: 'fixed',
                            // bottom: 0,
                            top:0,
                        }}>
                            <div style={{ width: '90%' }}
                                onClick={() => deeplinkurl && window.open(`${deeplinkurl}-myorders`,
                                    "_self")}>
                                <p style={{
                                    color: '#fff',
                                    fontSize: 18,
                                    marginBottom: 2,
                                    textAlign: "center"
                                }}>View in app</p>
                            </div>
                            <div>
                                <Icon type="close-circle"
                                    onClick={() => this.setState({ showDeeplinkViewApp: false })}
                                    style={{
                                        fontSize: '25px', color: '#fff', zIndex: 999
                                    }}
                                />
                            </div>
                        </div>
                    </MobileView>
    }

            </div >
        );
    }

};

export default withRouter(TransactionTemplateView);
